import React from 'react'

const Placeholder = () => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">Freigabe erforderlich</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">D.O.P.E. Mitgliederbereich</h1>
          <p className="mt-6 text-base leading-7 text-gray-600">Dein Benutzeraccount muss erst freigeschaltet werden, bevor du diese Funktion benutzen darfst. Du erhälst eine Mail sobald du freigeschaltet wurdest.</p>
          
        </div>
      </main>
    )
}

export default Placeholder